import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'

const instance = createInstance({
    urlBase: 'https://analytics.zedpro.me',
    siteId: 32,
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MatomoProvider value={instance}>
      <React.StrictMode>
          <App />
      </React.StrictMode>
  </MatomoProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
